<script setup lang="ts">
import type { AvatarProps, ButtonProps } from '@nuxt/ui'

defineProps<{
  avatar: AvatarProps
  backButton: ButtonProps
}>()
</script>

<template>
  <div class="bg-primary">
    <UContainer>
      <div class="py-6">
        <UButton v-bind="backButton" variant="link" color="neutral" class="text-white dark" icon="i-ph-arrow-left-light">Retour à la recherche</UButton>
      </div>
      <div class="flex gap-2 lg:gap-4 items-end">
        <div class="squircle p-1 bg-white size-22 lg:size-42 -mb-4 lg:-mb-14 ">
          <UAvatar class="rounded-none squircle w-full h-full" :src="avatar?.src ?? '/im/organization-avatar-default.png'" v-bind="avatar"></UAvatar>
        </div>
        <div class="pb-4 flex-1">
          <slot name="title" />
        </div>
      </div>
    </UContainer>
  </div>
  <UContainer class="pt-2 lg:min-h-14 min-h-4">
    <div class="flex gap-4">
      <div class="w-22 lg:w-42"></div>
      <div>
        <slot name="footer" />
      </div>
    </div>
  </UContainer>
</template>